exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#layoutSidenav_nav[data-v-9ce94604],.sb-sidenav[data-v-9ce94604]{overflow:hidden}.sb-sidenav-menu[data-v-9ce94604]{overflow-y:auto;-ms-overflow-style:none;scrollbar-width:none}.sb-sidenav-menu[data-v-9ce94604]::-webkit-scrollbar{display:none}", ""]);

// exports
